import { render, staticRenderFns } from "./FormValoracion.vue?vue&type=template&id=1907dcb2"
import script from "./FormValoracion.vue?vue&type=script&setup=true&lang=js"
export * from "./FormValoracion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports